// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".history{width:100%;padding:var(--section-padding-top) 0}.history_container{display:flex;justify-content:center}@media(min-width:640px){.history_container{justify-content:flex-end}}.history_content{position:relative;display:flex;flex-direction:column;width:100%}@media(min-width:992px){.history_content{flex:0 0 83.333%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
